import ag_grid_headers from './sq-AL/ag_grid_headers';
import antd_fields from './sq-AL/antd_fields';
import common from './sq-AL/common';
import contacts_pages from './sq-AL/contacts_pages';
import errors from './sq-AL/errors';
import menu from './sq-AL/menu';
import pages from './sq-AL/pages';
import success from './sq-AL/success';

export default {
    'navBar.lang': 'Gjuhët',
    'layout.user.link.help': 'Ndihmë',
    'layout.user.link.privacy': 'Privatësia',
    'layout.user.link.terms': 'Kushtet',
    'app.copyright.produced': 'Prodhuar nga ESIG SH.A.',
    'app.preview.down.block': 'Shkarkoni këtë faqe në projektin tuaj lokal',
    'app.welcome.link.fetch-blocks': 'Merr të gjithë bllokun',
    'app.welcome.link.block-list': "Ndërtimi i shpejtë standard, faqe të bazuara në zhvillimin e 'bllokut'",
    'component.read-more': 'Lexo më shumë',
    'app.pwa.offline': 'Tani je jashtë linje',
    'app.pwa.serviceworker.updated': 'Përmbajtja e re është në dispozicion',
    'app.pwa.serviceworker.updated.hint': 'Ju lutemi shtypni butonin "Rifresko" për të ringarkuar faqen aktuale',
    'app.pwa.serviceworker.updated.ok': 'Rifresko',
    'app.not_translated': 'I pa përkthyer',
    ...pages,
    ...menu,
    ...common,
    ...ag_grid_headers,
    ...antd_fields,
    ...contacts_pages,
    ...errors,
    ...success,
};
